const audioTitle = "_35sawmkgu5";
const audio = "_35saghgvt2";
const content = "_35sc1l1rf22";
const audioPlayer = "_35sa10rqwzt";

export { audio, audioPlayer, audioTitle, content };
import "./tile.audio.style.linaria.module.css";
//# sourceMappingURL=tile.audio.style.js.map
